import { api, unwrap, type APIResponse } from "./client";

// Mirrors app/routers/assistant.py.
export interface ChatTurn {
  role: "user" | "assistant";
  content: string;
}

export async function getAssistantStatus(): Promise<boolean> {
  try {
    const resp = await api.get<APIResponse<{ enabled: boolean }>>("/assistant/status");
    return Boolean(resp.data.data?.enabled);
  } catch {
    // A status probe must never break the page it's on.
    return false;
  }
}

export async function askAssistant(question: string, history: ChatTurn[]): Promise<string> {
  const resp = await api.post<APIResponse<{ answer: string }>>("/assistant/chat", {
    question,
    // Send only the recent turns; the server bounds this again.
    history: history.slice(-6),
  });
  return unwrap(resp.data).answer;
}

/** Friendly text for the failures this endpoint actually returns. */
export function assistantErrorMessage(err: unknown): string {
  const e = err as { response?: { status?: number; data?: { detail?: string } } };
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string" && detail) return detail;
  if (e?.response?.status === 429) {
    return "You've asked a lot of questions this hour — please try again later.";
  }
  if (e?.response?.status === 503) {
    return "The assistant is temporarily unavailable. Please try again in a moment.";
  }
  return "Something went wrong. Please try again, or contact support.";
}
